import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import UseOfProceedsUI from './UseOfProceedsUI.js'

class UseOfProceedsSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      deleteSubmitted: false,
      selectedBillId: null,
      downloadRequested: false,
      fileErrorList: null,
      onUpdateSubmitted: false,
      selectedBill: null,
      payMode: false,
    }
  }

  render() {
    return (
      <UseOfProceedsUI
        loan={this.props.loan}
        context={this.props.context}
        billList={this.props.billList}
        onRefreshClick={this.props.onRefreshClick}
        //
        onDeleteSubmit={this.onDeleteSubmit}
        deleteSubmitted={this.state.deleteSubmitted}
        selectedBillId={this.state.selectedBillId}
        selectedBill={this.state.selectedBill}
        //
        onDownloadBillClick={this.onDownloadBillClick}
        downloadRequested={this.state.downloadRequested}
        fileErrorList={this.state.fileErrorList}
        //
        onUpdateSubmitted={this.state.onUpdateSubmitted}
        onUpdateSubmitClick={this.onUpdateSubmitClick}
        onUpdateCancelClick={() => { this.setState({ onUpdateSubmitted: false }) }}
        //
        onPayClick={this.onPayClick}
        payMode={this.state.payMode}
        onPayCancel={() => { this.setState({ payMode: false }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
  }

  componentDidUpdate(prevProps) {
    let loan = this.props.loan
    if (!loan)
      return
    if (prevProps.loan && prevProps.loan.loanId == loan.loanId)
      return

    let context = this.props.context
  }

  onDeleteSubmit = (event) => {
    event.stopPropagation()
    let deleteSubmitted = this.state.deleteSubmitted
    if (deleteSubmitted)
      return

    let billId = event.target.getAttribute('data-row-id')

    this.setState({
      successMsg: null,
      errorList: [],
      deleteSubmitted: true,
      selectedBillId: billId
    })

    RestApiUtils.delete(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/bills/${billId}`, this.onDeleteCallback, {}
    )
  }

  onDeleteCallback = (response) => {
    let errorList = []

    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
      })
    }

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      deleteSubmitted: false
    })

    if (errorList.length === 0) {
      this.props.onRefreshClick('noBusy')
    }
  }

  onDownloadBillClick = (event) => {
    let vendorBillId = event.currentTarget.getAttribute('data-id')
    this.setState({ downloadRequested: true })
    RestApiUtils.get(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/vendorBills/${vendorBillId}/fileDownloadSignedUrl`,
      this.onDownloadBillClickCallback, null, null
    )
  }

  onDownloadBillClickCallback = (response) => {
    this.setState({
      fileErrorList: response.errorList,
      downloadRequested: false
    })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  onUpdateSubmitClick = (event) => {
    let selectedBillId = event.currentTarget.getAttribute('data-row-id')
    let selectedBill = this.props.billList.filter(bill => bill.vendorBillId === selectedBillId)[0]
    this.setState({ onUpdateSubmitted: true, selectedBillId: selectedBillId, selectedBill: selectedBill })
  }

  onPayClick = (event) => {
    let selectedBillId = event.currentTarget.getAttribute('data-row-id');
    let selectedBill = this.props.billList.filter((bill) => bill.vendorBillId === selectedBillId)[0];
    this.setState({ payMode: true, selectedBillId: selectedBillId, selectedBill: selectedBill });
  };

}

export default withRouter(UseOfProceedsSF)
